import { Injectable } from "@angular/core";
import { ItemHistory } from "src/services/history/history.types";
import { apiPath } from "../../shared/api-path.const";
import { ApiService } from "../http/api.service";

@Injectable({
  providedIn: "root",
})
export class ItemHistoryService {
  constructor(private readonly apiService: ApiService) {}

  public async getHistoryByItemId(itemId: string): Promise<ItemHistory[]> {
    return this.apiService.sendGetRequest<ItemHistory[]>(`${apiPath.item}/${itemId}/${apiPath.history}`, undefined);
  }
}
